<script setup lang="ts">
import { computed } from 'vue';

import { getBreakpoint } from '@sg-core/resources/assets/js/utils';
import type { PhxsgSliderProps as PhxsgCoreSliderProps } from '@sg-core/src/View/Components/Organisms/Slider';
import { mergeOptions } from '@sg-core/src/View/Components/Organisms/Slider/phxsg-slider.vue';

import { PhxsgContainer } from '../../Atoms/Container';
import { PhxsgSlider } from '../../Organisms/Slider';
import { PhxsgSliderProps } from '../Slider/phxsg-slider.vue';

const props = withDefaults(defineProps<PhxsgCoreSliderProps>(), {
  navigation: true,
  pagination: () => ({ xs: true, md: false }),
});

const tabletBreakpoint = getBreakpoint('md');

const mergedOptions = computed(() => {
  const defaultOptions: PhxsgCoreSliderProps = {
    slidesPerView: 'auto',
    centeredSlides: true,
    centeredSlidesBounds: true,
    breakpoints: {
      [tabletBreakpoint]: {
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
  };

  return mergeOptions(defaultOptions, props) as PhxsgSliderProps;
});
</script>

<template>
  <PhxsgContainer class="phxsg-card-slider-container">
    <PhxsgSlider class="phxsg-card-slider" v-bind="mergedOptions" controls-layout="outer">
      <slot />
    </PhxsgSlider>
  </PhxsgContainer>
</template>

<style src="./card-slider.css" />
